module.exports = __webpack_public_path__ + "3ebfbe9db64986f3251059791ade556a.MP3";